var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{attrs:{"type":"success","size":"lg"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fa fa-save fa-fw"}),_vm._v(_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }